import { render } from "./indexThree.vue?vue&type=template&id=87252f3a"
import script from "./indexThree.vue?vue&type=script&lang=js"
export * from "./indexThree.vue?vue&type=script&lang=js"

import "./indexThree.vue?vue&type=style&index=0&id=87252f3a&lang=css"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__